import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { FaBox, FaTruck, FaUsers, FaAward } from 'react-icons/fa';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Stats = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [animationStarted, setAnimationStarted] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.1,
  });
  const statsRef = useScrollAnimation(0.2);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`https://hub.mileageriot.com/api/basic-stats`);
        const data = await response.json();
        setStats(data.data);
      } catch (error) {
        console.error('Error fetching stats item data:', error);
      }
    };

    fetchStats();
  }, []);

  return (
    <section className="stats-modern py-5" ref={statsRef}>
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center mb-5 fade-in-up">
          <div className="section-badge">
            <FaAward className="me-2" />
            <span className="text-primary">{t('stats.title') || 'Our Statistics'}</span>
          </div>
          <h2 className="section-title text-glow text-white">
            {t('stats.mainTitle') || 'Achievement Numbers'}
          </h2>
          <div className="section-decoration"></div>
        </div>
        
        {/* Stats Cards */}
        <div className="row" ref={ref}>
          <div className="col-md-4 mb-4">
            <div className="stats-card-modern glass-container stagger-child">
              <div className="stats-icon-container">
                <FaTruck className="stats-icon text-primary"/>
                <div className="icon-glow"></div>
              </div>
              <div className="stats-content">
                <div className="stats-number text-white">
                  {stats && stats.distance ? (
                    <>
                      {animationStarted || inView ? (
                        <CountUp
                          start={0}
                          end={stats.distance}
                          duration={2.5}
                          decimals={0}
                          separator=","
                          onEnd={() => setAnimationStarted(true)}
                        />
                      ) : (
                        0
                      )}
                      <span className="stats-unit text-primary">KM</span>
                    </>
                  ) : (
                    <span className="text-white-50">{t('stats.loading') || 'Loading...'}</span>
                  )}
                </div>
                <div className="stats-label">
                  <span className="label-primary text-white">{t('stats.distance.title')}</span>
                  <span className="label-secondary text-primary">{t('stats.distance.subtitle')}</span>
                </div>
              </div>
              <div className="card-decoration"></div>
            </div>
          </div>
          
          <div className="col-md-4 mb-4">
            <div className="stats-card-modern glass-container stagger-child">
              <div className="stats-icon-container">
                <FaBox className="stats-icon text-primary"/>
                <div className="icon-glow"></div>
              </div>
              <div className="stats-content">
                <div className="stats-number text-white">
                  {stats && stats.jobs ? (
                    <>
                      {animationStarted || inView ? (
                        <CountUp
                          start={0}
                          end={stats.jobs}
                          duration={2.5}
                          decimals={0}
                          separator=","
                          onEnd={() => setAnimationStarted(true)}
                        />
                      ) : (
                        0
                      )}
                    </>
                  ) : (
                    <span className="text-white-50">{t('stats.loading') || 'Loading...'}</span>
                  )}
                </div>
                <div className="stats-label">
                  <span className="label-primary text-white">{t('stats.jobs.title')}</span>
                  <span className="label-secondary text-primary">{t('stats.jobs.subtitle')}</span>
                </div>
              </div>
              <div className="card-decoration"></div>
            </div>
          </div>
          
          <div className="col-md-4 mb-4">
            <div className="stats-card-modern glass-container stagger-child">
              <div className="stats-icon-container">
                <FaUsers className="stats-icon text-primary"/>
                <div className="icon-glow"></div>
              </div>
              <div className="stats-content">
                <div className="stats-number text-white">
                  {stats && stats.users ? (
                    <>
                      {animationStarted || inView ? (
                        <CountUp
                          start={0}
                          end={stats.users}
                          duration={2.5}
                          decimals={0}
                          separator=","
                          onEnd={() => setAnimationStarted(true)}
                        />
                      ) : (
                        0
                      )}
                    </>
                  ) : (
                    <span className="text-white-50">{t('stats.loading') || 'Loading...'}</span>
                  )}
                </div>
                <div className="stats-label">
                  <span className="label-primary text-white">{t('stats.users.title')}</span>
                  <span className="label-secondary text-primary">{t('stats.users.subtitle')}</span>
                </div>
              </div>
              <div className="card-decoration"></div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Background decoration */}
      <div className="section-bg-decoration"></div>
    </section>
  );
}; 

export default Stats;